(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('discover', {
            parent: 'app',
            url: '/discover',
            abstract: true,
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Discover'
            },
            views: {
                'content@': {
                    templateUrl: 'app/discover/discover.html',
                    controller: 'DiscoverController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('mosaic', {
            parent: 'discover',
            url: '/mosaic',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Discover'
            },
            views: {
                'content@discover': {
                    templateUrl: 'app/discover/mosaic.html',
                    controller: 'DiscoverController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('flow', {
            parent: 'discover',
            url: '/flow',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Discover'
            },
            views: {
                'content@discover': {
                    templateUrl: 'app/discover/flow.html',
                    controller: 'DiscoverController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
